import type { SupportedLanguages } from "@repo/database";
import { capitalize } from "@repo/utils";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { api } from "~/lib/api";

export const useUserManager = () => {
  const { t } = useTranslation("common");

  const { handleUserUpdate } = useUserUpdates();

  const { mutate: updateLanguage } = api.user.updateLanguage.useMutation({
    async onSuccess() {
      toast.success(
        capitalize(t("update_item_success", { item: t("User.language") })),
      );
      await handleUserUpdate();
    },
  });

  const updateUserLanguageHandler = async (language: SupportedLanguages) => {
    return await new Promise<boolean>((resolve) => {
      updateLanguage(language, {
        onSuccess() {
          return resolve(true);
        },
        onError() {
          resolve(false);
        },
      });
    });
  };

  return {
    updateUserLanguage: updateUserLanguageHandler,
  };
};

export const useUserUpdates = () => {
  const utils = api.useUtils();

  const handleUserUpdate = async () => {
    await utils.user.getUser.invalidate();
  };

  const handleUserDelete = (userId: string) => {
    void utils.section.getAll.setData(undefined, (old) => {
      if (!old) return old;
      return old.filter((p) => p.id !== userId);
    });
  };

  return {
    handleUserUpdate,
    handleUserDelete,
  };
};
